import styled from 'styled-components/macro'

export const Grid = styled.div<{ minWidth?: number }>`
  margin: 16px 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${props => props.minWidth ?? '288'}px, 1fr));
  gap: 16px;
`
